import { useParams } from 'react-router'
import useSWR from 'swr'

import { swrKeys } from '../../../../../../../swr/key'
import { getVideoStreamUrl } from '../request'

export const useVideoViewer = () => {
  const { trialUid = '', icfDocumentRevisionUid = '' } = useParams<{
    trialUid: string
    icfDocumentRevisionUid: string
  }>()

  const { data: videoStreamUrl, error } = useSWR<string, Error>(
    icfDocumentRevisionUid !== undefined
      ? swrKeys.getIcfDocumentVideoStreamUrl({
          trialUid,
          icfDocumentRevisionUid,
        })
      : null,
    () =>
      getVideoStreamUrl({
        trialUid,
        icfDocumentRevisionUid,
      }),
  )

  return {
    videoStreamUrl,
    error,
  }
}
